import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {
  Aangifte,
  Adres,
  AlimentatieGerechtigde, BokkzAlgDataService, IncomeTaxEntity,
  Persoon,
  PGAOnderhoudsverplichtingen
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SelectFormControlItem, SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {
    optionsLandcodesMetNLD,
} from "../../gedeelde-componenten/gedeelde-componenten.component";
import {filter, Subscription} from "rxjs";
import {Event, NavigationEnd, Router} from "@angular/router";
import {CommonModule} from "@angular/common";
import {SharedUiAlertModule} from "@snelstart/ui-alert";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SharedUiLoadingModule} from "@snelstart/ui-loading";
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";


@Component({
  selector: 'snelstart-venture-fiscaal-feature-pga-onderhoudsverplichtingen',
  templateUrl: './pga-onderhoudsverplichtingen.component.html',
  styleUrls: ['./pga-onderhoudsverplichtingen.component.scss'],
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiDialogModule,
    SharedUiButtonModule,
    CommonModule
  ]
})
export class PgaOnderhoudsverplichtingenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;

    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    private focusedElementId: string | null = null;

    public dialogVisible = false;
    public onderhoudsverplichtigenAangever = {} as FormGroup

    showDialog(index: number) {
        this.index = index;
        this.dialogVisible = true;
    }

    public index = 0;

    public optionsLandcodes: SelectFormControlItem<string>[] = optionsLandcodesMetNLD;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.onderhoudsverplichtigenAangever = this.fb.group({
            pgaOnderhoudsverplichtigenAangever:
                this.fb.array<PGAOnderhoudsverplichtingen>([])
        })
    }

    get pgaOnderhoudsverplichtigenAangever(): FormArray {
        return this.onderhoudsverplichtigenAangever.get('pgaOnderhoudsverplichtigenAangever') as FormArray;
    }

    addRijOnderhoudsverplichtigenAangever(): void {
        this.pgaOnderhoudsverplichtigenAangever.push(this.createOnderhoudsverplichtigenAangeverFormGroup()
        )
    }

    verwijderRijOnderhoudsverplichtigenAangever(index: number): void {
        this.pgaOnderhoudsverplichtigenAangever.removeAt(index);
        this.onderhoudsverplichtigenAangever.updateValueAndValidity()
        this.onderhoudsverplichtigenAangever.markAsDirty()
        this.saveForm()
    }

    createOnderhoudsverplichtigenAangeverFormGroup(onderhoud?: PGAOnderhoudsverplichtingen) {
        return this.fb.group({
            periodiekBetaald: onderhoud?.periodiekBetaald || undefined,
            betaaldeAfkoopsom: onderhoud?.betaaldeAfkoopsom || undefined,
            verrekeningPensioenrechten: onderhoud?.verrekeningPensioenrechten || undefined,
            bijstandEx: onderhoud?.bijstandEx || undefined,
            overigeOnderhoudsverplichtingen: onderhoud?.overigeOnderhoudsverplichtingen || undefined,
            exPartner: this.createAlimentatieGerechtigdeFormGroup(onderhoud?.exPartner) || undefined,
        })
    }

    // createOnroerendeZaakFormGroup(onroerendeZaak?: OnroerendeZaak) {
    //     return this.fb.group({
    //         // ... (add form controls for 'bewoondeWoningVanExPartner' here)
    //     });
    // }

    public createAlimentatieGerechtigdeFormGroup(exPartner ?: AlimentatieGerechtigde) {
        return this.fb.group({
            adresAlimentatieGerechtigde: this.createAdresFormGroup(exPartner?.adresAlimentatieGerechtigde) || undefined,
            gegevensAlimentatieGerechtigde: this.createGegevensAlimentatieGerechtigdeFormGroup(exPartner?.gegevensAlimentatieGerechtigde) || undefined,
        })
    }

    public createAdresFormGroup(adresAlimentatieGerechtigde?: Adres) {
        return this.fb.group({
            straat: adresAlimentatieGerechtigde?.straat || undefined,
            huisNummer: adresAlimentatieGerechtigde?.huisNummer || undefined,
            huisNummerToevoeging: adresAlimentatieGerechtigde?.huisNummerToevoeging || undefined,
            postcode: adresAlimentatieGerechtigde?.postcode || undefined,
            woonplaats: adresAlimentatieGerechtigde?.woonplaats || undefined,
            landCode: adresAlimentatieGerechtigde?.landCode || 'NLD',
        })
    }

    public createGegevensAlimentatieGerechtigdeFormGroup(gegevensAlimentatieGerechtigde ?: Persoon) {
        return this.fb.group({
            roepnaam: gegevensAlimentatieGerechtigde?.roepnaam || undefined,
            voorletters: gegevensAlimentatieGerechtigde?.voorletters || undefined,
            tussenvoegsels: gegevensAlimentatieGerechtigde?.tussenvoegsels || undefined,
            achternaam: gegevensAlimentatieGerechtigde?.achternaam || undefined,
            bsn: gegevensAlimentatieGerechtigde?.bsn || undefined,
            geboortedatum: gegevensAlimentatieGerechtigde?.geboortedatum || undefined,
            overlijdensdatum: gegevensAlimentatieGerechtigde?.overlijdensdatum || undefined,
            landCodeNationaliteit: gegevensAlimentatieGerechtigde?.landCodeNationaliteit || undefined,
        })
    }

    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.updateForm()
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
        this.routerSubscription = this.router.events
            .pipe(
                filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

  private hasUnsavedChanges(): boolean {
    return this.onderhoudsverplichtigenAangever.dirty;
  }


  private updateForm(): void {
        const onderhoudsverplichtingenLijst = this.aangifte?.persoonsgebondenAftrek?.pgaOnderhoudsverplichtingen || [];
        const formArray = this.onderhoudsverplichtigenAangever.get('pgaOnderhoudsverplichtigenAangever') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > onderhoudsverplichtingenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

      for (let i = 0; i < onderhoudsverplichtingenLijst.length; i++) {
          const exPartner = onderhoudsverplichtingenLijst[i];

          // Formatteer de postcode voordat deze wordt gepatcht
          if (exPartner.exPartner && exPartner.exPartner.adresAlimentatieGerechtigde?.postcode) {
              exPartner.exPartner.adresAlimentatieGerechtigde.postcode = this.formatPostcode(exPartner.exPartner.adresAlimentatieGerechtigde.postcode);
          }
          if (i < formArray.length) {
              const control = formArray.at(i) as FormGroup;
              control.patchValue(onderhoudsverplichtingenLijst[i]);
              control.get('bewoondeWoningVanExPartner')?.patchValue(onderhoudsverplichtingenLijst[i]?.bewoondeWoningVanExPartner || {});
              // if (onderhoudsverplichtingenLijst[i]?.bewoondeWoningVanExPartner?.adres?.postcode) {
              //     // Controleer of de volledige keten bestaat voordat je de waarde toewijst
              //     if (onderhoudsverplichtingenLijst[i]?.bewoondeWoningVanExPartner?.adres) {
              //         let postcode = onderhoudsverplichtingenLijst[i].bewoondeWoningVanExPartner?.adres.postcode
              //         postcode =
              //             this.formatPostcode(onderhoudsverplichtingenLijst[i].bewoondeWoningVanExPartner.adres.postcode);
              //     }
              // }

              control.get('exPartner')?.patchValue(onderhoudsverplichtingenLijst[i]?.exPartner || {});
          } else {
              const formGroup = this.createOnderhoudsverplichtigenAangeverFormGroup(onderhoudsverplichtingenLijst[i])
              formArray.push(formGroup);
          }
      }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        setTimeout(() => {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                persoonsgebondenAftrek: {
                    ...this.aangifte.persoonsgebondenAftrek,
                    pgaOnderhoudsverplichtingen: this.onderhoudsverplichtigenAangever.value.pgaOnderhoudsverplichtigenAangever
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        }, 200)
    }

    formatPostcode(postcode: string | null | undefined): string {
        if (!postcode) return ''; // Retourneer een lege string als postcode null of undefined is

        // Verwijder alle niet-alfanumerieke tekens (bijv. spaties)
        const cleanedPostcode = postcode.replace(/[^a-zA-Z0-9]/g, '');

        // Zorg voor 4 cijfers en 2 hoofdletters
        if (cleanedPostcode.length >= 4) {
            const cijfers = cleanedPostcode.substring(0, 4).replace(/\D/g, ''); // Alleen cijfers
            const letters = cleanedPostcode.substring(4, 6).replace(/[^a-zA-Z]/g, '').toUpperCase(); // Alleen letters
            return `${cijfers}${letters}`;
        }

        return cleanedPostcode; // Als de postcode te kort is, retourneer de schoongemaakte versie
    }
}
